import styled from "styled-components";

/**
 * Sits beside the settings gear (Footer/styled.ts, bottom-left) rather than anywhere in the
 * waveform columns: it is a status line, read on purpose when something feels slow, not something
 * to watch while working.
 */
export const ReadoutSC = styled.div`
    position: absolute;
    bottom: 24px;
    left: 62px;
    z-index: 5;
    font-size: 12px;
    line-height: 1.2;
    color: #8c8c8c;
    white-space: nowrap;
    cursor: help;
    user-select: none;
`;
